module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "garage-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "project-list-container"
  }, [_c('project-list')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "garage-fancy monospaced"
  }, [_c('p', [_vm._v("~ $ cd garage")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("~/garage $ cat README.md")]), _vm._v(" "), _c('p', [_vm._v("\n         - Here in my garage, just got this new "), _c('del', [_vm._v("Lamborghini")]), _vm._v("project here. \n         (It’s) fun to drive up here in the "), _c('del', [_vm._v("Hollywood")]), _vm._v("Torrey Pines hills.\n         ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("~/garage $ ./draw-a-frog")]), _vm._v(" "), _c('p', {
    staticClass: "asciiart"
  }, [_vm._v("\n  @..@        \n (\\--/)      \n(.>__<.)               \n^^^  ^^^ \n         ")]), _vm._v(" "), _c('p', [_vm._v("~/garage $ "), _c('span', {
    staticClass: "blinking-cursor"
  }, [_vm._v("_")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f61c258","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Garage.vue
// module id = 20
// module chunks = 0